import { getLeadsOptions } from "./get-leads";

export const getLeadsQueryKey = (organizationID: string) =>
  getLeadsOptions(organizationID).queryKey;
